var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 1.785 24 25m0-25-24 25",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgClose;